import { QueryClient } from "@tanstack/react-query";

export const createQueryClient = (isServer = false) => {
  const q = new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000, // 1 minute
        //
        refetchOnWindowFocus: false,
        retry: isServer ? false : undefined,
      },
      mutations: {
        retry: false,
      },
    },
  });

  return q;
};
